import type { FaireProductEntity } from "../../entity_types/product";

export const p_wy8hp45658: FaireProductEntity = {
  token: "p_wy8hp45658",
  type: "product",
  name: "S1228 | Knit Seamless Jacquard Mock Neck Long Sleeve Top",
  brandToken: "b_395xq4ekla",
  brandName: "By Together",
  imageUrl:
    "https://cdn.faire.com/fastly/2364bcdc479670249554070b736d266ba978192e64d94f6fcc05e7810687e285.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/832b56e2b7f095562cfc206368f3a1cc50a3cfa1d7971333455741b3a36f4bd0.jpeg",
    "https://cdn.faire.com/fastly/58094842e0fe09bec1511938bb88d20de0c690164e78d6936d2624a140f351d7.jpeg",
    "https://cdn.faire.com/fastly/dcad60fd6cb15bbf8854e163665113603b8f5ce7e626ee04ba36510c67b43d9a.jpeg",
    "https://cdn.faire.com/fastly/bffb04f08d6288a3063706d1c9737b1f75067bf18002ea9ef210a682d49aa2fe.jpeg",
    "https://cdn.faire.com/fastly/d0316604765641a29b81c80ed257b269ec06141a7cee91d0c78a7eaf27d79f5c.jpeg",
    "https://cdn.faire.com/fastly/e6e406a97435f78124957089be8efde6394a5cc39349b8ee4b3fce79a8f7e1e0.jpeg",
    "https://cdn.faire.com/fastly/09de5bf0cbe72c54d1cbb131b5e4459bedfbd93e7007defbad24fbc43af4050e.jpeg",
    "https://cdn.faire.com/fastly/9cf3e7446d3cf73e133487cfca46303effa66b2f04e674f000a5a40d2e8973eb.jpeg",
    "https://cdn.faire.com/fastly/c318930adefb506304927014332dab44c7bf9c939b53f1a53c37603b489b52f5.jpeg",
    "https://cdn.faire.com/fastly/3c5e8208a4ae67eb59e336452b7eff656c467d2da093eb92d97ca39120d6ba61.jpeg",
    "https://cdn.faire.com/fastly/4c6a0fbeb7ac779a8b44987a37444b5346b81c09e4f398b1a9dfe098b811ccf4.jpeg",
  ],
  priceDollars: 83.7,
  description:
    "This knit jacquard top features a see-through fishnet overlay, crafted from a 92% nylon and 8% spandex blend. The material is a stretchy knit that offers comfort and flexibility, making it perfect for layering or a stand-alone statement piece. The intricate jacquard pattern adds texture and visual interest, while the mock neck and long sleeves provide a sophisticated look.",
  tags: [],
  msrpDollars: 167.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:14:54.792Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
